







































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { AgencySettingsModule } from "@/store/modules/agencySettings";
import CreateConversationTopicRequest from "@/models/ConversationTopics/CreateConversationTopicRequest";
import GiganautVueDialog from "@/components/Shared/GiganautVueDialog";
import AgencyGroupStatus from "@/models/AgencyGroups/AgencyGroupStatus";
import ListUtils from "@/lib/listUtils";
import ConversationTopicDto from "@/models/ConversationTopics/ConversationTopicDto";
import ConversationTopicType from "@/models/ConversationTopics/ConversationTopicType";
import CreateConversationRequest from "@/models/Conversations/CreateConversationRequest";
import { MessagingModule } from "@/store/modules/messaging";
import { BookingDetailsModule } from "@/store/modules/bookingDetails";
import MessageBody from "@/components/Messages/Display/MessageBody.vue";
import ConversationParticipant from "@/components/Conversations/Display/ConversationParticipant.vue";
import { AppModule } from "@/store/modules/app";
import MessageDto from "@/models/Messages/MessageDto";
import ConversationParticipantDto from "@/models/Conversations/ConversationParticipantDto";
import BookingAssignConversation from '@/components/Conversations/BookingAssignConversation.vue';
import ConversationStatus from '@/components/Conversations/Display/ConversationStatus.vue';
import ConversationStatusEnum from '@/models/Conversations/ConversationStatus';
import BookingCreateConversationParticipant from '@/components/Conversations/BookingCreateConversationParticipant.vue';
import BookingConversationStatusEdit from '@/components/Conversations/BookingConversationStatusEdit.vue';
import EntityTypeEnum from "@/models/Shared/EntityType";
import CreateConversationParticipantRequest from "@/models/Conversations/CreateConversationParticipantRequest";

@Component({
  name: "BookingRoleWorkerConversation",
  components: { MessageBody, ConversationParticipant, BookingAssignConversation, BookingConversationStatusEdit, ConversationStatus, BookingCreateConversationParticipant },
})
export default class extends GiganautVueDialog {
  
  conversationStatus = ConversationStatusEnum;
  entityType = EntityTypeEnum
  newMessage = "";

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  get conversationExists() {
    return BookingDetailsModule.messages.length > 0;
  }

  get messages() {
    return BookingDetailsModule.messages;
  }

  get conversationParticipantsFiltered() {
    return BookingDetailsModule.conversationParticipants.filter(item => item.entityType !== EntityTypeEnum.ChatBot);
  }

  get conversation() {
    return BookingDetailsModule.conversation;
  }

  getParticipant(message: MessageDto) {
      return BookingDetailsModule.conversationParticipants.find((findParticipant: ConversationParticipantDto) => findParticipant.id === message.firebaseUserId);
  }

  getUserAvatarUrl(avatar: string, entityType: number, entityId: string) {
    return AppModule.currentAgencyContext.storageSharedBaseUrl + "/avatars/" + entityType.toString() + "/" + entityId + "/resized-100/" + avatar;
  }

  get isParticipant() {
    return this.conversation.participantFirebaseUserIds.includes(AppModule.currentUser.uid);
  }

  async joinConversation() {
    const request = new CreateConversationParticipantRequest();
    request.entityId = AppModule.userProfile.agencyUserId;
    request.entityType = this.EntityType.AgencyUser;
    await BookingDetailsModule.createConversationParticipant(request);
  }

  get agencyUsers() {
    return BookingDetailsModule.agencyUsers;
  }

  async sendMessage() {
    if (this.newMessage.trim() == '') {
      return;
    }
    await BookingDetailsModule.sendMessage(this.newMessage.trim());
    this.newMessage = '';
  }

    async startConversation() {
    if (this.newMessage.trim() == '') {
      return;
    }
    
    const request = new CreateConversationRequest();
    request.body = this.newMessage.trim();
    request.conversationTopicId = undefined;
    request.subject = undefined;
    request.workerId = undefined;
    await BookingDetailsModule.createBookingRoleWorkerConversation(request);
    this.newMessage = '';
    await BookingDetailsModule.updateConversation(
      BookingDetailsModule.offeredWorkersVM.selectedBookingRoleWorker
    );
  }

  async clearMessage() {}
}
